import m from 'mithril'

export default {
  view: vnode => {
    const image = require('./image22.jpg')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-05-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">
            Camp Century:
          </h3>

          <ul className="log-book-text">
            <li>Beliggenhed under isoverfladen: 6-7 meter</li>
            <li>Afstand fra Thule: 200 km mod øst        </li>                   
            <li>Antal tunneller: 26</li>
            <li>Samlet længde på tunneller: 3 kilometer </li>
            <li>Beboere: Max 200</li>            
          </ul>

          <figure className="log-book-figure">
            <img src={image} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              Tværsnit af Camp Century-tunnel med træbygning i.
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
